// extracted by mini-css-extract-plugin
module.exports = {"Content":"SearchResults_Content__WFdC0","ContentFlex":"SearchResults_ContentFlex__1L5pu"};